export default __webpack_public_path__ + "static/media/expand-less.3c9637ee.svg";